(function () {
  var root = document.getElementById('gmsPortal');
  var mount = document.getElementById('dpRoot');
  if (!root || !mount) return;
  var API = root.getAttribute('data-worker') + '/portal';
  var LOGO = root.getAttribute('data-logo');
  var SESSION_KEY = 'gms_portal_session';
  var MINIMUM_PRICE = 25;
  var ROLES = ['salesperson', 'manager', 'owner'];
  var STATUSES = ['draft', 'sent', 'accepted', 'declined', 'expired'];

  var state = { session: null, me: null, orgId: null, catalog: null, adminOrgs: null };

  // ---------- helpers ----------

  function h(tag, attrs, children) {
    var el = document.createElement(tag);
    attrs = attrs || {};
    Object.keys(attrs).forEach(function (k) {
      var v = attrs[k];
      if (v === null || v === undefined || v === false) return;
      if (k === 'class') el.className = v;
      else if (k === 'text') el.textContent = v;
      else if (k === 'html') el.innerHTML = v;
      else if (k === 'value') el.value = v;
      else if (k === 'checked') el.checked = !!v;
      else if (k === 'disabled') el.disabled = !!v;
      else if (k === 'hidden') el.hidden = !!v;
      else if (k.indexOf('on') === 0) el.addEventListener(k.slice(2), v);
      else el.setAttribute(k, v);
    });
    (children || []).forEach(function (c) {
      if (c === null || c === undefined || c === false) return;
      el.appendChild(typeof c === 'string' ? document.createTextNode(c) : c);
    });
    return el;
  }

  function money(n, currency) {
    var v = Math.abs(Number(n) || 0).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (Number(n) < 0 ? '-' : '') + '$' + v + (currency ? ' ' + currency : '');
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso);
    return d.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
  }

  function debounce(fn, ms) {
    var t;
    var wrapped = function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(null, args); }, ms);
    };
    wrapped.flush = function () { clearTimeout(t); fn(); };
    return wrapped;
  }

  var toastTimer;
  function toast(msg, isErr) {
    var old = document.querySelector('.dp-toast');
    if (old) old.remove();
    var el = h('div', { class: 'dp-toast' + (isErr ? ' dp-toast--err' : ''), text: msg });
    document.body.appendChild(el);
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.remove(); }, isErr ? 5000 : 2600);
  }

  function icon(name) {
    var paths = {
      back: '<path d="M19 12H5"/><path d="M12 19l-7-7 7-7"/>',
      undo: '<path d="M3 7v6h6"/><path d="M21 17a9 9 0 0 0-15-6.7L3 13"/>',
      redo: '<path d="M21 7v6h-6"/><path d="M3 17a9 9 0 0 1 15-6.7L21 13"/>',
      print: '<path d="M6 9V2h12v7"/><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"/><path d="M6 14h12v8H6z"/>',
      pdf: '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><path d="M7 10l5 5 5-5"/><path d="M12 15V3"/>',
      more: '<circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/><circle cx="5" cy="12" r="1.5"/>',
      plus: '<path d="M12 5v14"/><path d="M5 12h14"/>',
      x: '<path d="M18 6L6 18"/><path d="M6 6l12 12"/>',
      search: '<circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>',
      user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>'
    };
    var s = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    s.setAttribute('viewBox', '0 0 24 24');
    s.setAttribute('fill', 'none');
    s.setAttribute('stroke', 'currentColor');
    s.setAttribute('stroke-width', '2.2');
    s.setAttribute('stroke-linecap', 'round');
    s.setAttribute('stroke-linejoin', 'round');
    s.innerHTML = paths[name] || '';
    return s;
  }

  function api(path, opts) {
    opts = opts || {};
    var headers = { 'Content-Type': 'application/json' };
    if (state.session) headers.Authorization = 'Bearer ' + state.session;
    return fetch(API + path, {
      method: opts.method || 'GET',
      headers: headers,
      body: opts.body ? JSON.stringify(opts.body) : undefined
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (data) {
        if (r.status === 401) { clearSession(); render(); throw new Error(data.error || 'Signed out'); }
        if (!r.ok) { var e = new Error(data.error || 'Request failed'); e.status = r.status; e.data = data; throw e; }
        return data;
      });
    });
  }

  function saveSession(token) {
    state.session = token;
    try { localStorage.setItem(SESSION_KEY, token); } catch (e) {}
  }
  function clearSession() {
    state.session = null;
    state.me = null;
    try { localStorage.removeItem(SESSION_KEY); } catch (e) {}
  }

  // ---------- pricing (mirrors gms-cf src/pricing.js) ----------

  function toFeet(length, unit) {
    if (unit === 'inches') return length / 12;
    if (unit === 'feet') return length;
    return length / 304.8;
  }

  function bladeListPrice(item, blade) {
    var p = item && item.pricing;
    if (!p || !blade.width || !blade.tpi || !(blade.length > 0)) return { price: 0, error: !blade.width || !blade.tpi ? 'Choose width and TPI' : 'Enter loop length' };
    var ft = toFeet(blade.length, blade.unit || 'inches');
    if (ft < p.minLength || ft > p.maxLength) return { price: 0, error: 'Length must be between ' + p.minLength + ' and ' + p.maxLength + ' ft' };
    if (item.tpiMap[blade.width] && item.tpiMap[blade.width].indexOf(blade.tpi) === -1) return { price: 0, error: blade.tpi + ' TPI is not offered at ' + blade.width };
    return { price: Math.max(MINIMUM_PRICE, Math.round((ft * p.slope + p.intercept) * 100) / 100), error: '' };
  }

  function catalogById(id) {
    if (!state.catalog) return null;
    for (var i = 0; i < state.catalog.length; i++) if (state.catalog[i].id === id) return state.catalog[i];
    return null;
  }

  function computeLine(line) {
    var item = catalogById(line.catalogId);
    var r = { listPrice: 0, error: '', description: '' };
    if (line.kind === 'blade') {
      var b = line.blade || {};
      var res = bladeListPrice(item, b);
      r.listPrice = res.price;
      r.error = res.error;
      if (!res.error) r.description = b.width + ' wide, ' + b.tpi + ' TPI, ' + b.length + ' ' + (b.unit === 'inches' ? 'in' : b.unit) + ' loop (' + toFeet(b.length, b.unit).toFixed(2) + ' ft), welded to length';
    } else if (line.kind === 'product') {
      var v = null;
      if (item) item.variants.forEach(function (x) { if (x.id === (line.product || {}).variantId) v = x; });
      if (!v && item) v = item.variants[0];
      r.listPrice = v ? v.price : (line.listPrice || 0);
      r.description = line.description || '';
    } else if (line.kind === 'custom') {
      r.listPrice = Number(line.listPrice) || 0;
      r.error = line.title ? '' : 'Enter a description';
      r.description = line.description || '';
    }
    var unit = line.priceOverride !== null && line.priceOverride !== undefined && line.priceOverride !== '' ? Number(line.priceOverride) : r.listPrice;
    r.unitPrice = Math.round(unit * 100) / 100;
    r.total = line.kind === 'pending' || r.error ? 0 : Math.round(r.unitPrice * (Number(line.qty) || 1) * 100) / 100;
    return r;
  }

  function computeTotals(doc) {
    var subtotal = 0;
    doc.lines.forEach(function (l) { subtotal += computeLine(l).total; });
    subtotal = Math.round(subtotal * 100) / 100;
    var discount = Math.round(subtotal * (Number(doc.discountPct) || 0)) / 100;
    var shipping = Number(doc.shipping) || 0;
    var taxable = Math.round((subtotal - discount + shipping) * 100) / 100;
    var tax = Math.round(taxable * (Number(doc.taxPct) || 0)) / 100;
    return { subtotal: subtotal, discount: discount, shipping: shipping, tax: tax, total: Math.round((taxable + tax) * 100) / 100 };
  }

  // ---------- routing ----------

  function route() {
    var hash = location.hash.replace(/^#\/?/, '');
    var qi = hash.indexOf('?');
    var params = {};
    if (qi !== -1) {
      hash.slice(qi + 1).split('&').forEach(function (kv) { var p = kv.split('='); if (p[0]) params[decodeURIComponent(p[0])] = decodeURIComponent(p[1] || ''); });
      hash = hash.slice(0, qi);
    }
    var parts = hash.split('/').filter(Boolean);
    return { parts: parts, params: params };
  }

  function go(hash) { location.hash = hash; }

  function currentOrg() {
    var m = state.me;
    if (!m) return null;
    var found = null;
    m.memberships.forEach(function (x) { if (x.orgId === state.orgId) found = x; });
    if (found) return found;
    if (state.orgId && m.isAdmin && state.adminOrgs) {
      state.adminOrgs.forEach(function (o) { if (o.id === state.orgId) found = { orgId: o.id, orgName: o.name, orgCode: o.code, role: 'admin', discountPct: o.discount_pct }; });
      if (found) return found;
    }
    return m.memberships[0] || null;
  }

  // ---------- shell ----------

  var navEl = document.getElementById('dpNav');
  var barOrg = document.getElementById('dpBarOrg');

  function setBar(orgLabel, links) {
    barOrg.innerHTML = '';
    barOrg.appendChild(document.createTextNode('Distributor portal'));
    barOrg.appendChild(h('strong', { text: orgLabel }));
    navEl.innerHTML = '';
    links.forEach(function (l) { navEl.appendChild(l); });
  }

  function shell(active, content) {
    var org = currentOrg();
    var nav = [['quotes', 'Quotes']];
    if (state.me.isAdmin) nav.push(['admin', 'Admin']);
    nav.push(['account', 'Account']);
    setBar(org ? org.orgName : (state.me.isAdmin ? 'Graham Machine Sales admin' : 'No organization yet'), nav.map(function (n) {
      return h('a', { href: '#/' + n[0], class: active === n[0] ? 'active' : '', text: n[1] });
    }).concat([h('a', { href: '#', text: 'Sign out', onclick: function (e) { e.preventDefault(); signOut(); } })]));
    mount.innerHTML = '';
    mount.appendChild(content);
  }

  function signOut() {
    api('/logout', { method: 'POST' }).catch(function () {});
    clearSession();
    go('/');
    render();
  }

  // ---------- login ----------

  function renderLogin(message, isErr) {
    setBar('Sign in', [h('a', { href: '/', text: 'Back to site' })]);
    mount.innerHTML = '';
    var email = h('input', { type: 'email', placeholder: 'you@company.com', autocomplete: 'email', inputmode: 'email', id: 'dpEmail' });
    var btn = h('button', { class: 'dp-btn', type: 'submit', text: 'Email me a sign-in link' });
    var msg = message ? h('div', { class: 'dp-msg ' + (isErr ? 'dp-msg--err' : 'dp-msg--ok'), text: message }) : null;
    var form = h('form', {
      onsubmit: function (e) {
        e.preventDefault();
        btn.disabled = true;
        btn.textContent = 'Sending';
        api('/auth/request', { method: 'POST', body: { email: email.value } }).then(function () {
          renderLogin('Check your inbox. The link in the email signs you in on this device and works once.', false);
        }).catch(function (err) {
          btn.disabled = false;
          btn.textContent = 'Email me a sign-in link';
          renderLogin(err.message, true);
          var f = document.getElementById('dpEmail');
          if (f) { f.value = email.value; f.focus(); }
        });
      }
    }, [
      h('div', { class: 'dp-field' }, [h('label', { for: 'dpEmail', text: 'Work email' }), email]),
      btn
    ]);
    mount.appendChild(h('div', { class: 'dp-login' }, [
      h('div', { class: 'dp-card' }, [
        h('p', { class: 'dp-kicker', text: 'Distributor portal' }),
        h('h1', { class: 'dp-h1', text: 'Sign in' }),
        h('p', { text: 'Build and save quotes for Arntz blades, machines, and parts at your distributor pricing. No password: we email you a link.' }),
        msg,
        form,
        h('p', { class: 'dp-login-note', html: 'Not set up as a distributor yet? Call <a href="tel:+18009572690">1 (800) 957-2690</a> or <a href="/pages/contact?subject=Distributor%20account#ContactFormWrap">send us a note</a>.' })
      ])
    ]));
    if (!message) setTimeout(function () { email.focus(); }, 50);
  }

  // ---------- quotes list ----------

  function statusPill(status) {
    return h('span', { class: 'dp-status dp-status--' + status, text: status });
  }

  function orgSwitcher(onChange) {
    var m = state.me;
    var options = m.memberships.map(function (x) { return { id: x.orgId, name: x.orgName }; });
    if (m.isAdmin && state.adminOrgs) {
      state.adminOrgs.forEach(function (o) { if (!options.some(function (x) { return x.id === o.id; })) options.push({ id: o.id, name: o.name + ' (admin)' }); });
    }
    if (options.length < 2) return null;
    var sel = h('select', { onchange: function () { state.orgId = sel.value; onChange(); } }, options.map(function (o) {
      var opt = h('option', { value: o.id, text: o.name });
      if (o.id === state.orgId) opt.selected = true;
      return opt;
    }));
    sel.style.width = 'auto';
    sel.style.minWidth = '220px';
    return sel;
  }

  function renderQuotes() {
    var org = currentOrg();
    if (org) state.orgId = org.orgId;
    var list = h('div', { class: 'gms-list' });
    var filter = h('input', { type: 'text', placeholder: 'Filter by number, customer, status', oninput: function () { draw(); } });
    var quotes = [];
    var scope = 'own';
    function draw() {
      list.innerHTML = '';
      var q = filter.value.trim().toLowerCase();
      var shown = quotes.filter(function (x) { return !q || (x.number + ' ' + x.customerName + ' ' + x.status + ' ' + (x.userEmail || '')).toLowerCase().indexOf(q) !== -1; });
      if (!shown.length) {
        list.appendChild(h('div', { class: 'dp-empty', html: quotes.length ? 'No quotes match that filter.' : 'No quotes yet. Start one and it saves itself as you type.' }));
        return;
      }
      shown.forEach(function (x) {
        list.appendChild(h('a', { class: 'gms-row dp-quote-row', href: '#/quotes/' + x.id }, [
          h('span', { class: 'gms-row-media', text: x.number.replace(/^Q-/, '').replace(/-/, ' ') }),
          h('span', {}, [
            h('span', { class: 'gms-row-title', text: x.customerName || 'Untitled quote' }),
            h('span', { class: 'gms-row-meta' }, [statusPill(x.status), ' ', x.lineCount + ' item' + (x.lineCount === 1 ? '' : 's'), ' · updated ' + fmtDate(x.updatedAt), scope === 'org' || state.me.isAdmin ? ' · ' + (x.userName || x.userEmail) : ''])
          ]),
          h('span', { class: 'gms-row-right' }, [money(x.total), h('small', { text: x.number })])
        ]));
      });
    }
    var newBtn = h('button', { class: 'dp-btn', onclick: function () {
      if (!state.orgId) { toast('Your account is not attached to a distributor organization yet.', true); return; }
      newBtn.disabled = true;
      api('/quotes', { method: 'POST', body: { orgId: state.orgId } }).then(function (d) { go('/quotes/' + d.quote.id); }).catch(function (e) { newBtn.disabled = false; toast(e.message, true); });
    } }, [icon('plus'), 'New quote']);
    var head = h('div', { class: 'dp-head' }, [
      h('div', {}, [h('p', { class: 'dp-kicker', text: org ? org.orgName : 'Quotes' }), h('h1', { class: 'dp-h1', text: 'Quotes' }), h('p', { class: 'dp-sub', text: 'Every change saves automatically. Open a quote to keep editing, print it, or download the PDF.' })]),
      newBtn
    ]);
    var tools = h('div', { class: 'dp-tools' }, [h('div', { class: 'gms-search' }, [icon('search'), filter]), orgSwitcher(function () { go('/quotes?org=' + state.orgId); })]);
    shell('quotes', h('div', {}, [head, tools, list]));
    list.appendChild(h('div', { class: 'dp-empty', text: 'Loading quotes' }));
    if (!state.orgId) { list.innerHTML = ''; list.appendChild(h('div', { class: 'dp-empty', text: state.me.isAdmin ? 'Create an organization under Admin, then pick it here to quote on its behalf.' : 'Your account is not attached to a distributor organization yet. Call 1 (800) 957-2690.' })); return; }
    api('/quotes?org=' + encodeURIComponent(state.orgId)).then(function (d) { quotes = d.quotes; scope = d.scope; draw(); }).catch(function (e) { list.innerHTML = ''; list.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });
  }

  // ---------- quote editor ----------

  function renderEditor(id) {
    var quote = null;
    var doc = null;
    var editVersion = 0;
    var savedVersion = 0;
    var saving = false;
    var pendingSave = false;
    var container = h('div', {});
    shell('quotes', container);
    container.appendChild(h('div', { class: 'dp-empty', text: 'Loading quote' }));

    Promise.all([
      api('/quotes/' + id),
      state.catalog ? Promise.resolve({ items: state.catalog }) : api('/catalog')
    ]).then(function (res) {
      quote = res[0].quote;
      doc = quote.doc;
      state.orgId = quote.orgId;
      state.catalog = res[1].items;
      container.innerHTML = '';
      build();
    }).catch(function (e) { container.innerHTML = ''; container.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });

    var els = {};

    function markDirty() {
      editVersion++;
      doc.lines.forEach(function (l) { l.serverError = ''; });
      refreshTotals();
      setSaveState('Unsaved');
      scheduleSave();
    }

    function setSaveState(text, cls) {
      if (!els.save) return;
      els.save.textContent = text;
      els.save.className = 'qe-save' + (cls ? ' ' + cls : '');
    }

    var scheduleSave = debounce(function () { doSave(); }, 700);

    function doSave() {
      if (!quote || editVersion === savedVersion) return Promise.resolve();
      if (saving) { pendingSave = true; return Promise.resolve(); }
      saving = true;
      var version = editVersion;
      setSaveState('Saving', 'saving');
      return api('/quotes/' + quote.id, { method: 'PUT', body: { baseSeq: quote.seq, doc: doc } }).then(function (d) {
        savedVersion = version;
        quote = d.quote;
        applyServerDoc(quote.doc);
        setSaveState('Saved');
        updateUndoRedo();
      }).catch(function (e) {
        if (e.status === 409 && e.data && e.data.quote) {
          quote = e.data.quote;
          doc = quote.doc;
          savedVersion = editVersion;
          rebuildSheet();
          toast('This quote changed elsewhere. Reloaded the latest version.', true);
        } else {
          setSaveState('Not saved', 'saving');
          toast(e.message, true);
        }
      }).then(function () {
        saving = false;
        if (pendingSave) { pendingSave = false; doSave(); }
      });
    }

    function applyServerDoc(serverDoc) {
      var byId = {};
      (serverDoc.lines || []).forEach(function (l) { byId[l.id] = l; });
      doc.lines.forEach(function (line) {
        var s = byId[line.id];
        if (!s || s.kind !== line.kind) return;
        if (s.title && line.kind !== 'custom') line.title = s.title;
        if (s.sku) line.sku = s.sku;
        if (s.image) line.image = s.image;
        if (line.kind !== 'custom') line.listPrice = s.listPrice;
        line.serverError = s.error || '';
      });
      refreshTotals();
    }

    function step(direction) {
      var ready = editVersion !== savedVersion ? doSave() : Promise.resolve();
      ready.then(function () {
        return api('/quotes/' + quote.id + '/' + (direction < 0 ? 'undo' : 'redo'), { method: 'POST' });
      }).then(function (d) {
        quote = d.quote;
        doc = quote.doc;
        savedVersion = editVersion;
        rebuildSheet();
        updateUndoRedo();
        if (d.stepped) setSaveState('Saved');
      }).catch(function (e) { toast(e.message, true); });
    }

    function updateUndoRedo() {
      if (!els.undo) return;
      els.undo.disabled = !quote.canUndo;
      els.redo.disabled = !quote.canRedo;
      els.num.textContent = quote.number;
      els.statusPills.querySelectorAll('.gms-pill').forEach(function (p) { p.classList.toggle('active', p.getAttribute('data-status') === quote.status); });
    }

    function build() {
      var bar = h('div', { class: 'qe-bar' }, [h('div', { class: 'qe-bar-inner' }, [
        h('a', { class: 'qe-back', href: '#/quotes' }, [icon('back'), 'Quotes']),
        els.save = h('span', { class: 'qe-save', text: 'Saved' }),
        h('div', { class: 'qe-bar-right' }, [
          els.undo = h('button', { class: 'qe-icon-btn', title: 'Undo', 'aria-label': 'Undo', onclick: function () { step(-1); } }, [icon('undo')]),
          els.redo = h('button', { class: 'qe-icon-btn', title: 'Redo', 'aria-label': 'Redo', onclick: function () { step(1); } }, [icon('redo')]),
          h('button', { class: 'dp-btn dp-btn--ghost', onclick: function () { openPdf(true); } }, [icon('print'), 'Print']),
          h('button', { class: 'dp-btn', onclick: function () { openPdf(false); } }, [icon('pdf'), 'Save PDF']),
          menu()
        ])
      ])]);
      container.appendChild(bar);
      els.sheet = h('div', { class: 'qe-sheet' });
      container.appendChild(els.sheet);
      rebuildSheet();
      updateUndoRedo();
      document.addEventListener('keydown', keyHandler);
      window.addEventListener('hashchange', function off() { document.removeEventListener('keydown', keyHandler); window.removeEventListener('hashchange', off); scheduleSave.flush(); });
      window.addEventListener('beforeunload', function () { if (editVersion !== savedVersion) doSave(); });
    }

    function keyHandler(e) {
      var tag = (e.target.tagName || '').toLowerCase();
      var typing = tag === 'input' || tag === 'textarea' || tag === 'select';
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === 'z' && !typing) {
        e.preventDefault();
        step(e.shiftKey ? 1 : -1);
      }
    }

    function menu() {
      var list = h('div', { class: 'qe-menu-list', hidden: true }, [
        h('button', { text: 'Duplicate quote', onclick: function () { list.hidden = true; api('/quotes/' + quote.id + '/duplicate', { method: 'POST' }).then(function (d) { go('/quotes/' + d.quote.id); }).catch(function (e) { toast(e.message, true); }); } }),
        h('button', { text: 'Copy PDF link', onclick: function () { list.hidden = true; api('/quotes/' + quote.id + '/pdf-link', { method: 'POST' }).then(function (d) { return navigator.clipboard.writeText(d.url); }).then(function () { toast('PDF link copied. It works for 5 minutes.'); }).catch(function (e) { toast(e.message, true); }); } }),
        h('button', { class: 'danger', text: 'Delete quote', onclick: function () { list.hidden = true; if (!confirm('Delete ' + quote.number + '? An admin can restore it later.')) return; api('/quotes/' + quote.id, { method: 'DELETE' }).then(function () { go('/quotes'); }).catch(function (e) { toast(e.message, true); }); } })
      ]);
      var btn = h('button', { class: 'qe-icon-btn', 'aria-label': 'More', onclick: function (e) { e.stopPropagation(); list.hidden = !list.hidden; } }, [icon('more')]);
      document.addEventListener('click', function () { list.hidden = true; });
      return h('div', { class: 'qe-menu' }, [btn, list]);
    }

    function openPdf(inline) {
      var win = inline ? window.open('', '_blank') : null;
      var ready = editVersion !== savedVersion ? doSave() : Promise.resolve();
      ready.then(function () { return api('/quotes/' + quote.id + '/pdf-link', { method: 'POST' }); }).then(function (d) {
        var url = d.url + (inline ? '&inline=1' : '');
        if (win) win.location.href = url;
        else window.location.href = url;
      }).catch(function (e) { if (win) win.close(); toast(e.message, true); });
    }

    function field(label, key, obj, opts) {
      opts = opts || {};
      var input = opts.textarea
        ? h('textarea', { value: obj[key] || '', placeholder: opts.placeholder || '', rows: opts.rows || 2 })
        : h('input', { type: opts.type || 'text', value: obj[key] || '', placeholder: opts.placeholder || '', autocomplete: 'off' });
      input.addEventListener('input', function () { obj[key] = input.value; markDirty(); });
      return h('div', { class: 'dp-field' }, [h('label', { text: label }), input]);
    }

    function rebuildSheet() {
      var sheet = els.sheet;
      sheet.innerHTML = '';
      var c = doc.customer;
      els.statusPills = h('div', { class: 'gms-pills qe-status-pills' }, STATUSES.map(function (s) {
        return h('button', { type: 'button', class: 'gms-pill' + (quote.status === s ? ' active' : ''), 'data-status': s, text: s, onclick: function () {
          api('/quotes/' + quote.id + '/status', { method: 'PATCH', body: { status: s } }).then(function (d) { quote.status = d.quote.status; updateUndoRedo(); toast('Marked ' + s); }).catch(function (e) { toast(e.message, true); });
        } });
      }));
      sheet.appendChild(h('div', { class: 'qe-top' }, [
        h('img', { class: 'qe-logo', src: LOGO, alt: 'Graham Machine Sales' }),
        h('div', { class: 'qe-title' }, [h('h2', { text: 'QUOTE' }), els.num = h('p', { class: 'qe-num', text: quote.number }), els.statusPills])
      ]));
      var validInput = h('input', { type: 'date', value: doc.validUntil || '' });
      validInput.addEventListener('input', function () { doc.validUntil = validInput.value; markDirty(); });
      var refInput = h('input', { type: 'text', value: doc.reference || '', placeholder: 'PO or job number' });
      refInput.addEventListener('input', function () { doc.reference = refInput.value; markDirty(); });
      sheet.appendChild(h('div', { class: 'qe-meta' }, [
        h('div', { class: 'qe-block' }, [h('h4', { text: 'From' }), h('div', { class: 'qe-static', html: '<strong>Graham Machine Sales</strong>43 Bigwin Road, Unit 3<br>Hamilton, Ontario L8W 3R3<br>1 (800) 957-2690<br>sales@grahammachine.ca' })]),
        h('div', { class: 'qe-block' }, [h('h4', { text: 'Prepared for' }),
          field('Company', 'company', c, { placeholder: 'Company' }),
          field('Contact', 'contact', c, { placeholder: 'Name' }),
          field('Email', 'email', c, { type: 'email', placeholder: 'email@company.com' }),
          field('Phone', 'phone', c, { type: 'tel', placeholder: 'Phone' }),
          field('Address', 'address', c, { textarea: true, rows: 2, placeholder: 'Street, city, province, postal code' })
        ]),
        h('div', { class: 'qe-block' }, [h('h4', { text: 'Details' }),
          h('div', { class: 'qe-kv' }, [
            h('label', { text: 'Date' }), h('span', { text: fmtDate(quote.createdAt) }),
            h('label', { text: 'Valid until' }), validInput,
            h('label', { text: 'Reference' }), refInput,
            h('label', { text: 'Prepared by' }), h('span', { text: (quote.userName || quote.userEmail) + (quote.orgName ? ', ' + quote.orgName : '') })
          ]),
          h('div', { style: 'margin-top:14px' }, [field('Ship to (if different)', 'shipTo', doc, { textarea: true, rows: 2, placeholder: 'Leave blank to ship to the address above' })])
        ])
      ]));
      sheet.appendChild(h('div', { class: 'qe-thead' }, [h('span', { text: '#' }), h('span', { text: 'Item' }), h('span', { class: 'r', text: 'Qty' }), h('span', { class: 'r', text: 'Unit' }), h('span', { class: 'r', text: 'Total' }), h('span')]));
      els.lines = h('div', { class: 'qe-table' });
      sheet.appendChild(els.lines);
      renderLines();
      sheet.appendChild(h('button', { class: 'qe-add', type: 'button', onclick: function () { addLine(); } }, [icon('plus'), 'Add item']));
      var totals = h('div', { class: 'qe-totals' });
      els.totals = totals;
      sheet.appendChild(h('div', { class: 'qe-foot' }, [
        h('div', {}, [
          h('div', { class: 'qe-block' }, [h('h4', { text: 'Notes' }), field('', 'notes', doc, { textarea: true, rows: 3, placeholder: 'Anything the customer should know' }).lastChild]),
          h('div', { class: 'qe-block' }, [h('h4', { text: 'Terms' }), field('', 'terms', doc, { textarea: true, rows: 3 }).lastChild])
        ]),
        totals
      ]));
      buildTotals();
      refreshTotals();
    }

    function buildTotals() {
      var t = els.totals;
      t.innerHTML = '';
      var disc = h('input', { type: 'number', min: 0, max: 100, step: 0.5, value: doc.discountPct, inputmode: 'decimal' });
      disc.addEventListener('input', function () { doc.discountPct = Number(disc.value) || 0; markDirty(); });
      var ship = h('input', { type: 'number', min: 0, step: 0.01, value: doc.shipping, inputmode: 'decimal' });
      ship.addEventListener('input', function () { doc.shipping = Number(ship.value) || 0; markDirty(); });
      var tax = h('input', { type: 'number', min: 0, max: 100, step: 0.5, value: doc.taxPct, inputmode: 'decimal' });
      tax.addEventListener('input', function () { doc.taxPct = Number(tax.value) || 0; markDirty(); });
      els.tSub = h('span', { class: 'v' });
      els.tDisc = h('span', { class: 'v' });
      els.tShip = h('span', { class: 'v' });
      els.tTax = h('span', { class: 'v' });
      els.tTotal = h('span', { class: 'v grand' });
      [h('span', { class: 'k', text: 'Subtotal' }), els.tSub,
        h('span', { class: 'k' }, ['Discount', disc, ' %']), els.tDisc,
        h('span', { class: 'k ship' }, ['Shipping $', ship]), els.tShip,
        h('span', { class: 'k' }, ['Tax', tax, ' %']), els.tTax,
        h('span', { class: 'k grand', text: 'Total ' + (doc.currency || 'CAD') }), els.tTotal
      ].forEach(function (x) { t.appendChild(x); });
    }

    function refreshTotals() {
      if (!els.tSub) return;
      var t = computeTotals(doc);
      els.tSub.textContent = money(t.subtotal);
      els.tDisc.textContent = t.discount ? '-' + money(t.discount) : money(0);
      els.tShip.textContent = money(t.shipping);
      els.tTax.textContent = money(t.tax);
      els.tTotal.textContent = money(t.total);
      doc.lines.forEach(function (line) {
        var row = els.lines.querySelector('[data-line="' + line.id + '"]');
        if (!row) return;
        var r = computeLine(line);
        var tot = row.querySelector('.qe-total');
        if (tot) { tot.textContent = r.error || line.kind === 'pending' ? 'TBD' : money(r.total); tot.classList.toggle('tbd', !!r.error); }
        var unit = row.querySelector('.qe-unit input');
        if (unit && document.activeElement !== unit) unit.value = r.unitPrice ? r.unitPrice.toFixed(2) : '';
        var listEl = row.querySelector('.qe-unit-list');
        if (listEl) {
          var overridden = line.priceOverride !== null && line.priceOverride !== undefined && line.priceOverride !== '';
          listEl.innerHTML = '';
          if (overridden && r.listPrice) {
            listEl.appendChild(document.createTextNode('list ' + money(r.listPrice)));
            listEl.appendChild(h('button', { type: 'button', text: 'reset', onclick: function () { line.priceOverride = null; markDirty(); refreshTotals(); } }));
          }
        }
        var desc = row.querySelector('.qe-line-desc');
        if (desc && line.kind === 'blade') desc.textContent = r.description;
        var errText = r.error || line.serverError || '';
        var err = row.querySelector('.qe-line-err');
        if (err) { err.textContent = errText; err.hidden = !errText; }
        row.classList.toggle('has-err', !!errText);
      });
    }

    function newLineId() { return 'ln_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36); }

    function addLine() {
      var line = { id: newLineId(), kind: 'pending', catalogId: '', qty: 1, priceOverride: null, note: '' };
      doc.lines.push(line);
      var row = lineRow(line, doc.lines.length);
      els.lines.appendChild(row);
      var input = row.querySelector('input');
      if (input) input.focus();
    }

    function removeLine(line) {
      doc.lines = doc.lines.filter(function (l) { return l !== line; });
      renderLines();
      if (line.kind !== 'pending') markDirty();
    }

    function renderLines() {
      els.lines.innerHTML = '';
      doc.lines.forEach(function (line, i) { els.lines.appendChild(lineRow(line, i + 1)); });
      if (!doc.lines.length) addLine();
    }

    function lineRow(line, n) {
      if (line.kind === 'pending') return pendingRow(line, n);
      var item = catalogById(line.catalogId);
      var r = computeLine(line);
      var main = h('div', { class: 'qe-line-main' + (line.image ? '' : ' noimg') }, [
        line.image ? h('div', { class: 'qe-thumb' }, [h('img', { src: line.image, alt: '' })]) : null,
        h('div', {}, [
          line.kind === 'custom'
            ? (function () { var t = h('input', { type: 'text', value: line.title || '', placeholder: 'Describe the item', class: 'qe-custom-title' }); t.addEventListener('input', function () { line.title = t.value; markDirty(); }); return h('div', { class: 'dp-field', style: 'margin:0' }, [t]); })()
            : h('div', { class: 'qe-line-title', text: line.title }),
          line.sku ? h('div', { class: 'qe-line-sku', text: 'SKU ' + line.sku }) : null,
          h('div', { class: 'qe-line-desc', text: r.description, hidden: line.kind === 'custom' }),
          lineFields(line, item),
          h('div', { class: 'qe-line-err', text: r.error, hidden: !r.error }),
          noteField(line)
        ])
      ]);
      var qty = h('input', { type: 'number', min: 1, max: 10000, step: 1, value: line.qty, inputmode: 'numeric', 'aria-label': 'Quantity' });
      qty.addEventListener('input', function () { line.qty = Math.max(1, parseInt(qty.value, 10) || 1); markDirty(); });
      var unit = h('input', { type: 'number', min: 0, step: 0.01, value: r.unitPrice ? r.unitPrice.toFixed(2) : '', inputmode: 'decimal', 'aria-label': 'Unit price', placeholder: '0.00' });
      unit.addEventListener('input', function () {
        var v = unit.value === '' ? null : Number(unit.value);
        if (line.kind === 'custom') { line.listPrice = v || 0; line.priceOverride = null; }
        else line.priceOverride = v === null || Math.abs(v - computeLine({ kind: line.kind, catalogId: line.catalogId, blade: line.blade, product: line.product, qty: 1, priceOverride: null, listPrice: line.listPrice }).listPrice) < 0.005 ? null : v;
        markDirty();
      });
      var row = h('div', { class: 'qe-line' + (r.error ? ' has-err' : ''), 'data-line': line.id }, [
        h('div', { class: 'qe-line-n', text: String(n) }),
        main,
        h('div', { class: 'qe-mobile-row' }, [
          h('div', { class: 'qe-qty' }, [qty]),
          h('div', { class: 'qe-unit' }, [unit, h('div', { class: 'qe-unit-list' })]),
          h('div', { class: 'qe-total' + (r.error ? ' tbd' : ''), text: r.error ? 'TBD' : money(r.total) }),
          h('button', { class: 'qe-remove', type: 'button', 'aria-label': 'Remove line', onclick: function () { removeLine(line); } }, [icon('x')])
        ])
      ]);
      return row;
    }

    function noteField(line) {
      var wrap = h('div', { class: 'qe-note' });
      function showInput() {
        wrap.innerHTML = '';
        var inp = h('input', { type: 'text', value: line.note || '', placeholder: 'Note shown on the quote for this line' });
        inp.addEventListener('input', function () { line.note = inp.value; markDirty(); });
        wrap.appendChild(inp);
        return inp;
      }
      if (line.note) showInput();
      else wrap.appendChild(h('button', { type: 'button', class: 'qe-note-add', text: '+ Note', onclick: function () { showInput().focus(); } }));
      return wrap;
    }

    function lineFields(line, item) {
      var wrap = h('div', { class: 'qe-fields' });
      if (line.kind === 'blade' && item) {
        var b = line.blade;
        var width = h('select', {}, [h('option', { value: '', text: 'Width' })].concat(item.widths.map(function (w) {
          var o = h('option', { value: w.value, text: w.label }); if (w.value === b.width) o.selected = true; return o;
        })));
        var tpiWrap = h('div', { class: 'qe-tpi-pills' });
        function drawTpi() {
          tpiWrap.innerHTML = '';
          var opts = item.tpiMap[b.width] || [];
          if (!opts.length) { tpiWrap.appendChild(h('span', { class: 'dp-muted', text: 'Pick a width first' })); return; }
          opts.forEach(function (t) {
            tpiWrap.appendChild(h('button', { type: 'button', class: 'gms-pill' + (b.tpi === t ? ' active' : ''), text: t, onclick: function () { b.tpi = t; drawTpi(); markDirty(); } }));
          });
        }
        width.addEventListener('change', function () { b.width = width.value; if ((item.tpiMap[b.width] || []).indexOf(b.tpi) === -1) b.tpi = ''; drawTpi(); markDirty(); });
        drawTpi();
        var len = h('input', { type: 'number', min: 0, step: 0.1, value: b.length || '', placeholder: 'e.g. 185', inputmode: 'decimal' });
        len.addEventListener('input', function () { b.length = Number(len.value) || 0; markDirty(); });
        var unitSel = h('select', {}, ['inches', 'mm', 'feet'].map(function (u) { var o = h('option', { value: u, text: u === 'inches' ? 'in' : u }); if (u === b.unit) o.selected = true; return o; }));
        unitSel.addEventListener('change', function () { b.unit = unitSel.value; markDirty(); });
        wrap.appendChild(h('div', { class: 'dp-field' }, [h('label', { text: 'Width' }), width]));
        wrap.appendChild(h('div', { class: 'dp-field' }, [h('label', { text: 'Loop length' }), h('div', { class: 'qe-len' }, [len, unitSel])]));
        wrap.appendChild(h('div', { class: 'dp-field wide' }, [h('label', { text: 'Teeth per inch' }), tpiWrap]));
      } else if (line.kind === 'product' && item && item.variants.length > 1) {
        var sel = h('select', {}, item.variants.map(function (v) { var o = h('option', { value: v.id, text: (v.title || 'Standard') + ' · ' + money(v.price) }); if (v.id === line.product.variantId) o.selected = true; return o; }));
        sel.addEventListener('change', function () { line.product.variantId = sel.value; var v = item.variants.filter(function (x) { return x.id === sel.value; })[0]; line.product.variantTitle = v ? v.title : ''; line.sku = v && v.sku ? v.sku : item.sku; markDirty(); });
        wrap.appendChild(h('div', { class: 'dp-field' }, [h('label', { text: 'Option' }), sel]));
      } else if (line.kind === 'product') {
        var d = h('input', { type: 'text', value: line.description || '', placeholder: 'Optional detail (size, model, colour)' });
        d.addEventListener('input', function () { line.description = d.value; markDirty(); });
        wrap.appendChild(h('div', { class: 'dp-field wide' }, [h('label', { text: 'Detail' }), d]));
      } else if (line.kind === 'custom') {
        var cd = h('input', { type: 'text', value: line.description || '', placeholder: 'Optional detail' });
        cd.addEventListener('input', function () { line.description = cd.value; markDirty(); });
        wrap.appendChild(h('div', { class: 'dp-field wide' }, [h('label', { text: 'Detail' }), cd]));
      }
      return wrap;
    }

    function pendingRow(line, n) {
      var input = h('input', { type: 'text', placeholder: 'Type a blade, machine, or part name', autocomplete: 'off', 'aria-label': 'Search products' });
      var list = h('div', { class: 'qe-combo-list', hidden: true });
      var active = -1;
      var results = [];
      function draw() {
        list.innerHTML = '';
        var q = input.value.trim().toLowerCase();
        var terms = q.split(/\s+/).filter(Boolean);
        results = (state.catalog || []).map(function (item) {
          var title = item.title.toLowerCase();
          var score = 0;
          for (var i = 0; i < terms.length; i++) {
            var t = terms[i];
            if (title.indexOf(t) === 0) score += 4; else if (title.indexOf(t) !== -1) score += 2; else if (item.keywords.indexOf(t) !== -1) score += 1; else return null;
          }
          return { item: item, score: score };
        }).filter(Boolean).sort(function (a, b) { return b.score - a.score || a.item.title.localeCompare(b.item.title); }).slice(0, 10).map(function (r) { return r.item; });
        results.forEach(function (item, i) {
          var meta = item.kind === 'blade' ? 'Custom welded blade · ' + item.productType : (item.productType || item.vendor || 'Product');
          var right = item.kind === 'blade' ? 'Priced by length' : (item.variants[0] ? money(item.variants[0].price) : '');
          var row = h('button', { type: 'button', class: 'gms-row gms-row--compact' + (i === active ? ' active' : ''), onmousedown: function (e) { e.preventDefault(); choose(item); } }, [
            h('span', { class: 'gms-row-media' }, [item.image ? h('img', { src: item.image, alt: '' }) : null]),
            h('span', {}, [h('span', { class: 'gms-row-title', text: item.title }), h('span', { class: 'gms-row-meta', text: (item.sku ? item.sku + ' · ' : '') + meta })]),
            h('span', { class: 'gms-row-right', text: right })
          ]);
          list.appendChild(row);
        });
        var customLabel = q ? 'Add "' + input.value.trim() + '" as a custom line' : 'Add a custom line (freight, labour, anything)';
        list.appendChild(h('button', { type: 'button', class: 'gms-row gms-row--compact qe-combo-custom' + (active === results.length ? ' active' : ''), onmousedown: function (e) { e.preventDefault(); choose(null); } }, [
          h('span', { class: 'gms-row-media' }, [icon('plus')]),
          h('span', {}, [h('span', { class: 'gms-row-title', text: customLabel })])
        ]));
        list.hidden = false;
      }
      function choose(item) {
        var idx = doc.lines.indexOf(line);
        var next;
        if (!item) next = { id: line.id, kind: 'custom', catalogId: '', title: input.value.trim(), sku: '', image: '', description: '', listPrice: 0, qty: 1, priceOverride: null, note: '' };
        else if (item.kind === 'blade') next = { id: line.id, kind: 'blade', catalogId: item.id, title: item.title, sku: item.sku, image: item.image, blade: { productLine: item.productLine, width: item.widths.length === 1 ? item.widths[0].value : '', tpi: '', length: 0, unit: 'inches' }, qty: 1, priceOverride: null, note: '' };
        else next = { id: line.id, kind: 'product', catalogId: item.id, title: item.title, sku: item.variants[0] && item.variants[0].sku ? item.variants[0].sku : item.sku, image: item.image, product: { productId: item.id.split(':')[1], variantId: item.variants[0] ? item.variants[0].id : '', variantTitle: item.variants[0] ? item.variants[0].title : '' }, description: '', qty: 1, priceOverride: null, note: '' };
        doc.lines[idx] = next;
        var row = lineRow(next, idx + 1);
        els.lines.replaceChild(row, els.lines.children[idx]);
        markDirty();
        var focusTarget = row.querySelector('.qe-fields select, .qe-fields input, .qe-custom-title, .qe-qty input');
        if (focusTarget) focusTarget.focus();
      }
      input.addEventListener('focus', draw);
      input.addEventListener('input', function () { active = -1; draw(); });
      input.addEventListener('blur', function () { setTimeout(function () { list.hidden = true; }, 120); });
      input.addEventListener('keydown', function (e) {
        var count = results.length + 1;
        if (e.key === 'ArrowDown') { e.preventDefault(); active = (active + 1) % count; draw(); }
        else if (e.key === 'ArrowUp') { e.preventDefault(); active = (active - 1 + count) % count; draw(); }
        else if (e.key === 'Enter') { e.preventDefault(); if (active === -1 && results.length) choose(results[0]); else if (active >= 0 && active < results.length) choose(results[active]); else choose(null); }
        else if (e.key === 'Escape') { list.hidden = true; if (!input.value) removeLine(line); }
      });
      return h('div', { class: 'qe-line pending', 'data-line': line.id }, [
        h('div', { class: 'qe-line-n', text: String(n) }),
        h('div', { class: 'qe-combo' }, [icon('search'), input, list]),
        h('button', { class: 'qe-remove', type: 'button', 'aria-label': 'Remove line', onclick: function () { removeLine(line); } }, [icon('x')])
      ]);
    }
  }

  // ---------- account ----------

  function renderAccount() {
    var me = state.me;
    var name = h('input', { type: 'text', value: me.user.name || '', placeholder: 'Shown on quotes you prepare' });
    var phone = h('input', { type: 'tel', value: me.user.phone || '' });
    var btn = h('button', { class: 'dp-btn', type: 'submit', text: 'Save' });
    var form = h('form', { onsubmit: function (e) {
      e.preventDefault();
      btn.disabled = true;
      api('/me', { method: 'PUT', body: { name: name.value, phone: phone.value } }).then(function () { me.user.name = name.value; me.user.phone = phone.value; toast('Saved'); }).catch(function (err) { toast(err.message, true); }).then(function () { btn.disabled = false; });
    } }, [
      h('div', { class: 'dp-field' }, [h('label', { text: 'Email' }), h('input', { type: 'email', value: me.user.email, disabled: true })]),
      h('div', { class: 'dp-field' }, [h('label', { text: 'Your name' }), name]),
      h('div', { class: 'dp-field' }, [h('label', { text: 'Phone' }), phone]),
      btn
    ]);
    var orgs = h('div', { class: 'dp-card' }, [h('div', { class: 'dp-section-title', text: 'Your organizations' })].concat(me.memberships.length ? me.memberships.map(function (m) {
      return h('div', { class: 'dp-chip' }, [m.orgName + ' · ' + m.role + (m.discountPct ? ' · ' + m.discountPct + '% off list' : '')]);
    }) : [h('p', { class: 'dp-muted', text: me.isAdmin ? 'You are a Graham Machine Sales admin.' : 'None yet.' })]));
    shell('account', h('div', { class: 'dp-stack' }, [
      h('div', { class: 'dp-head' }, [h('div', {}, [h('p', { class: 'dp-kicker', text: 'Account' }), h('h1', { class: 'dp-h1', text: 'Your details' })])]),
      h('div', { class: 'dp-card' }, [form]),
      orgs
    ]));
  }

  // ---------- admin ----------

  function loadAdminOrgs() {
    return api('/admin/orgs').then(function (d) { state.adminOrgs = d.orgs; return d; });
  }

  function renderAdmin() {
    var content = h('div', { class: 'dp-stack' });
    shell('admin', content);
    content.appendChild(h('div', { class: 'dp-head' }, [
      h('div', {}, [h('p', { class: 'dp-kicker', text: 'Admin' }), h('h1', { class: 'dp-h1', text: 'Organizations' }), h('p', { class: 'dp-sub', text: 'Each distributor is an organization. Anyone whose email matches its domain or email list can sign in and quote at its discount.' })]),
      h('div', { class: 'dp-bar-nav', style: 'margin:0' }, [h('a', { href: '#/admin/users', text: 'Users' }), h('a', { href: '#/admin/quotes', text: 'All quotes' })])
    ]));
    var name = h('input', { type: 'text', placeholder: 'Organization name' });
    var code = h('input', { type: 'text', placeholder: 'Auto', maxlength: 8, style: 'text-transform:uppercase' });
    var domain = h('input', { type: 'text', placeholder: 'company.com' });
    var discount = h('input', { type: 'number', min: 0, max: 100, step: 0.5, value: 0 });
    var createBtn = h('button', { class: 'dp-btn', type: 'submit', text: 'Create' });
    content.appendChild(h('div', { class: 'dp-card' }, [
      h('div', { class: 'dp-section-title', text: 'New organization' }),
      h('form', { class: 'dp-inline', onsubmit: function (e) {
        e.preventDefault();
        createBtn.disabled = true;
        var access = domain.value.trim() ? [{ kind: domain.value.indexOf('@') !== -1 ? 'email' : 'domain', value: domain.value.trim(), defaultRole: 'salesperson' }] : [];
        api('/admin/orgs', { method: 'POST', body: { name: name.value, code: code.value, discountPct: discount.value, access: access } }).then(function (d) { go('/admin/orgs/' + d.org.id); }).catch(function (err) { createBtn.disabled = false; toast(err.message, true); });
      } }, [
        h('div', { class: 'dp-field' }, [h('label', { text: 'Name' }), name]),
        h('div', { class: 'dp-field sm' }, [h('label', { text: 'Quote prefix' }), code]),
        h('div', { class: 'dp-field' }, [h('label', { text: 'Allowed domain or email' }), domain]),
        h('div', { class: 'dp-field sm' }, [h('label', { text: 'Discount %' }), discount]),
        createBtn
      ])
    ]));
    var table = h('div', { class: 'dp-card' }, [h('div', { class: 'dp-empty', text: 'Loading' })]);
    content.appendChild(table);
    loadAdminOrgs().then(function (d) {
      table.innerHTML = '';
      if (!d.orgs.length) { table.appendChild(h('div', { class: 'dp-empty', text: 'No organizations yet. Create the first one above.' })); return; }
      var tbl = h('table', { class: 'dp-table' }, [
        h('thead', {}, [h('tr', {}, [h('th', { text: 'Organization' }), h('th', { text: 'Access' }), h('th', { class: 'r', text: 'Members' }), h('th', { class: 'r', text: 'Quotes' }), h('th', { class: 'r', text: 'Discount' }), h('th', { text: 'Status' })])]),
        h('tbody', {}, d.orgs.map(function (o) {
          return h('tr', { style: 'cursor:pointer', onclick: function () { go('/admin/orgs/' + o.id); } }, [
            h('td', {}, [h('strong', { text: o.name }), h('div', { class: 'dp-muted', text: 'Q-' + o.code + '-' })]),
            h('td', { text: o.access_count + ' rule' + (o.access_count === 1 ? '' : 's') }),
            h('td', { class: 'r', text: String(o.member_count) }),
            h('td', { class: 'r', text: String(o.quote_count) }),
            h('td', { class: 'r', text: o.discount_pct + '%' }),
            h('td', {}, [statusPill(o.status === 'active' ? 'accepted' : 'declined')])
          ]);
        }))
      ]);
      tbl.querySelectorAll('.dp-status').forEach(function (s, i) { s.textContent = d.orgs[i].status; });
      table.appendChild(h('div', { style: 'overflow-x:auto' }, [tbl]));
      table.appendChild(h('p', { class: 'dp-muted', style: 'margin:14px 0 0', text: 'Admin sign-in is open to: ' + d.adminDomains.map(function (x) { return '@' + x; }).join(', ') + '. Individual users can also be made admins under Users.' }));
    }).catch(function (e) { table.innerHTML = ''; table.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });
  }

  function renderAllQuotes() {
    var content = h('div', {});
    shell('admin', content);
    content.appendChild(h('div', { class: 'dp-head' }, [h('div', {}, [h('p', { class: 'dp-kicker', text: 'Admin' }), h('h1', { class: 'dp-h1', text: 'All quotes' })]), h('a', { class: 'dp-btn dp-btn--ghost', href: '#/admin', text: 'Back to admin' })]));
    var list = h('div', { class: 'gms-list' }, [h('div', { class: 'dp-empty', text: 'Loading' })]);
    content.appendChild(list);
    api('/quotes?scope=all&archived=1').then(function (d) {
      list.innerHTML = '';
      if (!d.quotes.length) { list.appendChild(h('div', { class: 'dp-empty', text: 'No quotes yet.' })); return; }
      d.quotes.forEach(function (x) {
        list.appendChild(h('a', { class: 'gms-row dp-quote-row', href: '#/quotes/' + x.id, style: x.archivedAt ? 'opacity:0.55' : '' }, [
          h('span', { class: 'gms-row-media', text: x.number.replace(/^Q-/, '').replace(/-/, ' ') }),
          h('span', {}, [h('span', { class: 'gms-row-title', text: (x.customerName || 'Untitled') + ' · ' + x.orgName }), h('span', { class: 'gms-row-meta' }, [statusPill(x.status), ' ' + (x.userName || x.userEmail) + ' · ' + fmtDate(x.updatedAt) + (x.archivedAt ? ' · deleted' : '')])]),
          h('span', { class: 'gms-row-right' }, [money(x.total), h('small', { text: x.number })])
        ]));
      });
    }).catch(function (e) { list.innerHTML = ''; list.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });
  }

  function renderAdminOrg(id) {
    var content = h('div', { class: 'dp-stack' });
    shell('admin', content);
    content.appendChild(h('div', { class: 'dp-empty', text: 'Loading' }));
    api('/admin/orgs/' + id).then(function (d) { draw(d); }).catch(function (e) { content.innerHTML = ''; content.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });

    function draw(d) {
      var o = d.org;
      content.innerHTML = '';
      content.appendChild(h('div', { class: 'dp-head' }, [
        h('div', {}, [h('p', { class: 'dp-kicker', text: 'Organization' }), h('h1', { class: 'dp-h1', text: o.name }), h('p', { class: 'dp-sub', text: 'Quotes numbered Q-' + o.code + '-#### · ' + d.stats.quotes + ' quotes worth ' + money(d.stats.value) })]),
        h('div', { style: 'display:flex;gap:8px;flex-wrap:wrap' }, [
          h('button', { class: 'dp-btn dp-btn--ghost', text: 'View quotes', onclick: function () { state.orgId = o.id; go('/quotes?org=' + o.id); } }),
          h('a', { class: 'dp-btn dp-btn--ghost', href: '#/admin', text: 'All organizations' })
        ])
      ]));

      var f = {
        name: h('input', { type: 'text', value: o.name }),
        discount: h('input', { type: 'number', min: 0, max: 100, step: 0.5, value: o.discount_pct }),
        phone: h('input', { type: 'tel', value: o.phone }),
        address: h('textarea', { value: o.address, rows: 2 }),
        notes: h('textarea', { value: o.notes, rows: 2, placeholder: 'Internal notes, never shown to the distributor' }),
        status: h('select', {}, [h('option', { value: 'active', text: 'Active' }), h('option', { value: 'inactive', text: 'Inactive (sign-in blocked)' })])
      };
      f.status.value = o.status;
      var saveBtn = h('button', { class: 'dp-btn', type: 'submit', text: 'Save changes' });
      content.appendChild(h('div', { class: 'dp-card' }, [
        h('div', { class: 'dp-section-title', text: 'Details' }),
        h('form', { onsubmit: function (e) {
          e.preventDefault();
          saveBtn.disabled = true;
          api('/admin/orgs/' + o.id, { method: 'PUT', body: { name: f.name.value, discountPct: f.discount.value, phone: f.phone.value, address: f.address.value, notes: f.notes.value, status: f.status.value } })
            .then(function (nd) { state.adminOrgs = null; toast('Saved'); draw(nd); }).catch(function (err) { saveBtn.disabled = false; toast(err.message, true); });
        } }, [
          h('div', { class: 'dp-grid2' }, [
            h('div', { class: 'dp-field' }, [h('label', { text: 'Name' }), f.name]),
            h('div', { class: 'dp-field' }, [h('label', { text: 'Discount off list, %' }), f.discount]),
            h('div', { class: 'dp-field' }, [h('label', { text: 'Phone' }), f.phone]),
            h('div', { class: 'dp-field' }, [h('label', { text: 'Status' }), f.status])
          ]),
          h('div', { class: 'dp-field' }, [h('label', { text: 'Address (prefilled on their quotes)' }), f.address]),
          h('div', { class: 'dp-field' }, [h('label', { text: 'Internal notes' }), f.notes]),
          saveBtn
        ])
      ]));

      var accVal = h('input', { type: 'text', placeholder: 'company.com or person@company.com' });
      var accRole = h('select', {}, ROLES.map(function (r) { return h('option', { value: r, text: r }); }));
      var accBtn = h('button', { class: 'dp-btn', type: 'submit', text: 'Allow' });
      content.appendChild(h('div', { class: 'dp-card' }, [
        h('div', { class: 'dp-section-title', text: 'Who can sign in' }),
        h('p', { class: 'dp-muted', style: 'margin:0 0 12px', text: 'A domain lets everyone at that company in. An email lets one person in. New sign-ins get the default role shown.' }),
        h('div', {}, d.access.length ? d.access.map(function (a) {
          return h('span', { class: 'dp-chip' }, [(a.kind === 'domain' ? '@' : '') + a.value + ' · ' + a.default_role, h('button', { type: 'button', text: '×', title: 'Remove', onclick: function () {
            api('/admin/orgs/' + o.id + '/access/' + a.id, { method: 'DELETE' }).then(draw).catch(function (err) { toast(err.message, true); });
          } })]);
        }) : [h('p', { class: 'dp-muted', text: 'Nobody can sign in yet. Add a domain or email.' })]),
        h('form', { class: 'dp-inline', style: 'margin-top:12px', onsubmit: function (e) {
          e.preventDefault();
          accBtn.disabled = true;
          var v = accVal.value.trim();
          api('/admin/orgs/' + o.id + '/access', { method: 'POST', body: { kind: v.indexOf('@') !== -1 ? 'email' : 'domain', value: v, defaultRole: accRole.value } }).then(draw).catch(function (err) { accBtn.disabled = false; toast(err.message, true); });
        } }, [
          h('div', { class: 'dp-field' }, [h('label', { text: 'Domain or email' }), accVal]),
          h('div', { class: 'dp-field sm' }, [h('label', { text: 'Default role' }), accRole]),
          accBtn
        ])
      ]));

      var memEmail = h('input', { type: 'email', placeholder: 'person@company.com' });
      var memRole = h('select', {}, ROLES.map(function (r) { return h('option', { value: r, text: r }); }));
      var memBtn = h('button', { class: 'dp-btn', type: 'submit', text: 'Add member' });
      content.appendChild(h('div', { class: 'dp-card' }, [
        h('div', { class: 'dp-section-title', text: 'Members' }),
        h('p', { class: 'dp-muted', style: 'margin:0 0 12px', text: 'Salesperson: own quotes. Manager: every quote in the organization. Owner: also manages members (coming to their portal later).' }),
        d.members.length ? h('div', { style: 'overflow-x:auto' }, [h('table', { class: 'dp-table' }, [
          h('thead', {}, [h('tr', {}, [h('th', { text: 'Person' }), h('th', { text: 'Role' }), h('th', { text: 'Last sign-in' }), h('th')])]),
          h('tbody', {}, d.members.map(function (m) {
            var roleSel = h('select', { onchange: function () { api('/admin/orgs/' + o.id + '/members/' + m.id, { method: 'PUT', body: { role: roleSel.value } }).then(function () { toast('Role updated'); }).catch(function (err) { toast(err.message, true); }); } }, ROLES.map(function (r) { var op = h('option', { value: r, text: r }); if (r === m.role) op.selected = true; return op; }));
            return h('tr', {}, [
              h('td', {}, [h('strong', { text: m.name || m.email }), m.name ? h('div', { class: 'dp-muted', text: m.email }) : null, m.is_admin ? h('div', { class: 'dp-muted', text: 'GMS admin' }) : null]),
              h('td', {}, [roleSel]),
              h('td', { class: 'dp-muted', text: m.last_login_at ? fmtDate(m.last_login_at) : 'Never' }),
              h('td', { class: 'r' }, [h('button', { class: 'dp-btn dp-btn--ghost dp-btn--sm', text: 'Remove', onclick: function () { if (!confirm('Remove ' + m.email + ' from ' + o.name + '?')) return; api('/admin/orgs/' + o.id + '/members/' + m.id, { method: 'DELETE' }).then(draw).catch(function (err) { toast(err.message, true); }); } })])
            ]);
          }))
        ])]) : h('p', { class: 'dp-muted', text: 'Nobody has signed in yet. Members appear here automatically on first sign-in, or add one now.' }),
        h('form', { class: 'dp-inline', style: 'margin-top:12px', onsubmit: function (e) {
          e.preventDefault();
          memBtn.disabled = true;
          api('/admin/orgs/' + o.id + '/members', { method: 'POST', body: { email: memEmail.value, role: memRole.value } }).then(draw).catch(function (err) { memBtn.disabled = false; toast(err.message, true); });
        } }, [
          h('div', { class: 'dp-field' }, [h('label', { text: 'Email' }), memEmail]),
          h('div', { class: 'dp-field sm' }, [h('label', { text: 'Role' }), memRole]),
          memBtn
        ])
      ]));
    }
  }

  function renderAdminUsers() {
    var content = h('div', { class: 'dp-stack' });
    shell('admin', content);
    content.appendChild(h('div', { class: 'dp-head' }, [h('div', {}, [h('p', { class: 'dp-kicker', text: 'Admin' }), h('h1', { class: 'dp-h1', text: 'Users' })]), h('a', { class: 'dp-btn dp-btn--ghost', href: '#/admin', text: 'Back to admin' })]));
    var card = h('div', { class: 'dp-card' }, [h('div', { class: 'dp-empty', text: 'Loading' })]);
    content.appendChild(card);
    api('/admin/users').then(function (d) {
      card.innerHTML = '';
      card.appendChild(h('div', { style: 'overflow-x:auto' }, [h('table', { class: 'dp-table' }, [
        h('thead', {}, [h('tr', {}, [h('th', { text: 'Person' }), h('th', { class: 'r', text: 'Orgs' }), h('th', { class: 'r', text: 'Quotes' }), h('th', { text: 'Last sign-in' }), h('th', { text: 'Admin' }), h('th')])]),
        h('tbody', {}, d.users.map(function (u) {
          var cb = h('input', { type: 'checkbox', checked: u.is_admin === 1, style: 'width:20px;height:20px;min-height:0', onchange: function () {
            api('/admin/users/' + u.id, { method: 'PUT', body: { isAdmin: cb.checked } }).then(function () { toast('Updated'); }).catch(function (err) { cb.checked = !cb.checked; toast(err.message, true); });
          } });
          return h('tr', {}, [
            h('td', {}, [h('strong', { text: u.name || u.email }), u.name ? h('div', { class: 'dp-muted', text: u.email }) : null]),
            h('td', { class: 'r', text: String(u.org_count) }),
            h('td', { class: 'r', text: String(u.quote_count) }),
            h('td', { class: 'dp-muted', text: u.last_login_at ? fmtDate(u.last_login_at) : 'Never' }),
            h('td', {}, [cb]),
            h('td', { class: 'r' }, [h('button', { class: 'dp-btn dp-btn--ghost dp-btn--sm', text: 'Sign out everywhere', onclick: function () { api('/admin/users/' + u.id + '/revoke-sessions', { method: 'POST' }).then(function () { toast('Sessions revoked'); }).catch(function (err) { toast(err.message, true); }); } })])
          ]);
        }))
      ])]));
    }).catch(function (e) { card.innerHTML = ''; card.appendChild(h('div', { class: 'dp-msg dp-msg--err', text: e.message })); });
  }

  // ---------- boot ----------

  function render() {
    if (!state.session) { renderLogin(); return; }
    var r = route();
    var p = r.parts;
    if (r.params.org) state.orgId = r.params.org;
    var ensureMe = state.me ? Promise.resolve() : api('/me').then(function (m) {
      state.me = m;
      if (!state.orgId && m.memberships.length) state.orgId = m.memberships[0].orgId;
      if (m.isAdmin) return loadAdminOrgs().then(function () { if (!state.orgId && state.adminOrgs.length) state.orgId = state.adminOrgs[0].id; }).catch(function () {});
    });
    ensureMe.then(function () {
      if (!state.session) return;
      if (p[0] === 'quotes' && p[1]) renderEditor(p[1]);
      else if (p[0] === 'admin' && state.me.isAdmin && p[1] === 'orgs' && p[2]) renderAdminOrg(p[2]);
      else if (p[0] === 'admin' && state.me.isAdmin && p[1] === 'users') renderAdminUsers();
      else if (p[0] === 'admin' && state.me.isAdmin && p[1] === 'quotes') renderAllQuotes();
      else if (p[0] === 'admin' && state.me.isAdmin) renderAdmin();
      else if (p[0] === 'account') renderAccount();
      else renderQuotes();
    }).catch(function (e) {
      if (state.session) { mount.innerHTML = ''; mount.appendChild(h('div', { class: 'dp-login' }, [h('div', { class: 'dp-card' }, [h('div', { class: 'dp-msg dp-msg--err', text: e.message }), h('button', { class: 'dp-btn', text: 'Retry', onclick: render })])])); }
    });
  }

  var m = location.hash.match(/[#&]session=([A-Za-z0-9_-]+)/);
  if (m) {
    saveSession(m[1]);
    history.replaceState(null, '', location.pathname + location.search + '#/quotes');
  } else {
    try { state.session = localStorage.getItem(SESSION_KEY); } catch (e) {}
  }
  window.addEventListener('hashchange', render);
  render();
})();
